export default "__VITE_ASSET__DTIRHME1__"